import { CreateModalType } from '../types/types'

/**
 * Mixpanel event names are a published interface — every saved report built on
 * `Button Press: Create - <X>` breaks if the name changes. The menu labels are
 * localized, so tracking reads its suffix from this map instead of from the
 * rendered label, keeping event names identical across locales.
 */
export const CREATE_MODAL_ANALYTICS_LABELS: Record<CreateModalType, string> = {
  incident: 'Incident',
  facility: 'Facility',
  floor: 'Floor',
  device: 'Device',
  sop: 'SOP',
  gateway: 'Gateway',
  pacs: 'PACS',
  rule: 'Rule (Legacy)',
  automation: 'Automation',
  case: 'Case',
}
